import {
  DECREASE_PENDING_FILES_COUNT
} from "../types";


const decreasePendingFiles= () => {
  return({type: DECREASE_PENDING_FILES_COUNT});
};
export default decreasePendingFiles;